const localState = sessionStorage.getItem('state');
let rootState = {
  tagsList: [], // 头部tab切换
  userInfo: {
    name: ''
  },
  personalDetails: {},
  imgurl: '',
  headerimgurl: '', //头像的地址
  nikename: '', //昵称
  titleName: '会计考证',
  isShowLogin: {}, //是否显示登录弹窗
  currentStep: "1",
  isToggleTheme:false,
}
let studentsState = {}
let teachersState = {
  teacher_courselist: {}, //教师端课程列表
}

if (localState) {
  let state = JSON.parse(localState)
  rootState.tagsList = state.tagsList || []; // 头部tab切换
  rootState.isToggleTheme=state.isToggleTheme || false;
  rootState.userInfo = state.userInfo;
  rootState.personalDetails = state.personalDetails;
  rootState.isShowLogin = state.isShowLogin;
  rootState.currentStep = state.currentStep;
}

export default {
  rootState,
  studentsState,
  teachersState,
}


// WEBPACK FOOTER //
// ./src/store/state.js